/** Holds system level base infos. */
import _ from 'lodash'
import { xhrGet } from '../../util/xhr-apis'

/** initial state */
const state = {
  resourceType: '', // 1级（教学教案，试题试卷，微课）
  province: {}, // 1级 （省份）
  major: {}, // 2级 (专业，根据省份)
  subject: {}, // 2级（学科，根据专业）
  nav: {}, // 2级（菜单，根据type）
  version: {}, // 3级 （版本，根据专业,学科，省份）
  versionNavs: {}, // 3级 版本学科菜单 （根据学科，版本，菜单）
  chooseObj: {}, // 4级 （筛选项）
  firstChapt: {},
  textBook: {}, // 具体教材
  textBookChapter: {}, // 章节
  resourceInputNav: {}, // 资源录入菜单
  resourceStatus: {}, // 资源列表状态
  typeChange: '' // 资源类型切换
}

/** getters */
// const getters = {}

/**
 * Template method for fetch and cache base datas.
 * @param {*} state vue state
 * @param {*} commit vue commit
 */
let xhrSetActionHelper = (state, commit, stateName, url) => {
  if (!_.isEmpty(state[stateName])) {
    // console.log(`using ${stateName} cache...`)
    return Promise.resolve(state[stateName])
  }
  return xhrGet(url)
    .then(rs => {
      let rsData = rs.data
      let mutationName = 'set' + _.upperFirst(stateName)
      commit(mutationName, rsData)
      return rsData
    }).catch(err => console.log('error: ' + err))
}

/** actions */
const actions = {
  xhrExamPublish ({ state, commit }, id) {
    return xhrSetActionHelper(state, commit, 'examPublish', `/publishes/${id}`)
  }
}

/** mutations */
const mutations = {
  setResourceType (state, val) {
    state.resourceType = val
  },
  setMajor (state, val) {
    state.major = val
  },
  setSubject (state, val) {
    state.subject = val
  },
  setProvince (state, val) {
    state.province = val
  },
  setNav (state, val) {
    state.nav = val
  },
  setVersion (state, val) {
    state.version = val
  },
  setVersionNavs (state, val) {
    state.versionNavs = val
  },
  setChooseObj (state, val) {
    state.chooseObj = val
  },
  // 默认第一册
  setFirstChapt (state, val) {
    state.firstChapt = val
  },
  setTextBook (state, val) {
    state.textBook = val
  },
  setTextBookChapter (state, val) {
    state.textBookChapter = val
  },
  setResourceInputNav (state, val) {
    state.resourceInputNav = val
  },
  setResourceStatus (state, val) {
    state.resourceStatus = val
  },
  setTypeChange (state, val) {
    state.typeChange = val
  }
}

/* export for using */
export default {
  namespaced: true,
  state,
  // getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/sso/store/modules/resource.js